












































import {Component, Watch} from 'vue-property-decorator';
import dataProxy from '@/services/data-proxy.service'
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {formatPrice} from "@/utils/formatters";
import * as _ from 'lodash';
import moment from "moment";

@Component
export default class PredjeniKilometriIPotrosnjaGoriva extends mixins(ComponentBaseMixin) {
    godina = 0;
    predjeniKilometri = [];
    potrosnjaGoriva = [];
    isBusy = false;
    options = {
        pagination: true, showFooter: true, footerStyle() {
            return {
                css: {'font-weight': 'bold'}
            }
        }
    };

    columns = [];

    async created() {
        this.columns = [
            {
                field: 'podGrupa',
                title: this.$i18n.t('grupaVozila'),
                width: 300,
                footerFormatter: this.$i18n.t('ukupno')
            },
            {
                field: 'januar',
                title: this.$i18n.t('januar'),
                width: 120,
                formatter: formatPrice,
                align: 'right',
                footerFormatter: (data) => formatPrice(_.sumBy(data, 'januar'))
            },
            {
                field: 'februar',
                title: this.$i18n.t('februar'),
                width: 120,
                formatter: formatPrice,
                align: 'right',
                footerFormatter: (data) => formatPrice(_.sumBy(data, 'februar'))
            },
            {
                field: 'mart',
                title: this.$i18n.t('mart'),
                width: 120,
                formatter: formatPrice,
                align: 'right',
                footerFormatter: (data) => formatPrice(_.sumBy(data, 'mart'))
            },
            {
                field: 'april',
                title: this.$i18n.t('april'),
                width: 120,
                formatter: formatPrice,
                align: 'right',
                footerFormatter: (data) => formatPrice(_.sumBy(data, 'april'))
            },
            {
                field: 'maj',
                title: this.$i18n.t('maj'),
                width: 120,
                formatter: formatPrice,
                align: 'right',
                footerFormatter: (data) => formatPrice(_.sumBy(data, 'maj'))
            },
            {
                field: 'jun',
                title: this.$i18n.t('jun'),
                width: 120,
                formatter: formatPrice,
                align: 'right',
                footerFormatter: (data) => formatPrice(_.sumBy(data, 'jun'))
            },
            {
                field: 'jul',
                title: this.$i18n.t('jul'),
                width: 120,
                formatter: formatPrice,
                align: 'right',
                footerFormatter: (data) => formatPrice(_.sumBy(data, 'jul'))
            },
            {
                field: 'avgust',
                title: this.$i18n.t('avgust'),
                width: 120,
                formatter: formatPrice,
                align: 'right',
                footerFormatter: (data) => formatPrice(_.sumBy(data, 'avgust'))
            },
            {
                field: 'septembar',
                title: this.$i18n.t('septembar'),
                width: 120,
                formatter: formatPrice,
                align: 'right',
                footerFormatter: (data) => formatPrice(_.sumBy(data, 'septembar'))
            },
            {
                field: 'oktobar',
                title: this.$i18n.t('oktobar'),
                width: 120,
                formatter: formatPrice,
                align: 'right',
                footerFormatter: (data) => formatPrice(_.sumBy(data, 'oktobar'))
            },
            {
                field: 'novembar',
                title: this.$i18n.t('novembar'),
                width: 120,
                formatter: formatPrice,
                align: 'right',
                footerFormatter: (data) => formatPrice(_.sumBy(data, 'novembar'))
            },
            {
                field: 'decembar',
                title: this.$i18n.t('decembar'),
                width: 120,
                formatter: formatPrice,
                align: 'right',
                footerFormatter: (data) => formatPrice(_.sumBy(data, 'decembar'))
            },
            {
                field: 'total',
                title: this.$i18n.t('ukupno'),
                width: 120,
                formatter: formatPrice,
                align: 'right',
                footerFormatter: (data) => formatPrice(_.sumBy(data, 'total'))
            },
        ]
    }

    @Watch('godina') async onGodinaChanged(godina) {
        if (godina) {
            if (this.isBusy) return;
            try {
                this.isBusy = true;
                const report = await this.loadData(() => dataProxy.izvestajiProxy.vratiIzvestajPredjenihKilometaraIPotrosnjeGorivaPoGrupamaVozila(godina))();
                this.predjeniKilometri = report.predjeniKilometri;
                this.potrosnjaGoriva = report.potrosenoGorivo;
            } finally {
                this.isBusy = false;
            }
        }
    }
}
